import { render, staticRenderFns } from "./privacy-statement.vue?vue&type=template&id=22b47d5b&scoped=true&"
import script from "./privacy-statement.vue?vue&type=script&lang=js&"
export * from "./privacy-statement.vue?vue&type=script&lang=js&"
import style0 from "./privacy-statement.vue?vue&type=style&index=0&id=22b47d5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b47d5b",
  null
  
)

export default component.exports